import { render, staticRenderFns } from "./ActiveFilter.vue?vue&type=template&id=4322f547&scoped=true"
import script from "./ActiveFilter.vue?vue&type=script&lang=js"
export * from "./ActiveFilter.vue?vue&type=script&lang=js"
import style0 from "./ActiveFilter.vue?vue&type=style&index=0&id=4322f547&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4322f547",
  null
  
)

export default component.exports